import { Box, Flex, Image, Text } from '@chakra-ui/react'

const icons = {
  'functionFilter': '/assets/icons/functionFilter.svg',
  'tagFilter': '/assets/icons/tagFilter.svg',
  'recurringEventFilter': '/assets/icons/meetingFilter.svg',
  'meeting': '/assets/icons/meetingFilter.svg'
}

const Chip = ({type, label, subLabel}) => {
  return (
    <Flex
      bg='#F5F7F9'
      borderRadius='32px'
      py='8px'
      px='12px'
      border='1px solid #E4E6E8'
      alignItems='center'
      alignSelf='center'
      flexShrink={0}
    >
      <Image boxSize={4} mr='4px' src={icons[type]} />
      <Text color='#565B69' fontSize='14px' lineHeight='17px' fontWeight='500'>
        {label}
        &nbsp;
        <Box as='span' color='#565B69' opacity='0.5'>
          {subLabel}
        </Box>
      </Text>
    </Flex>
  )
}

export default Chip